import { render, staticRenderFns } from "./ActiveAccreditedSchools.vue?vue&type=template&id=6d3fd373&scoped=true"
import script from "./ActiveAccreditedSchools.vue?vue&type=script&lang=js"
export * from "./ActiveAccreditedSchools.vue?vue&type=script&lang=js"
import style0 from "./ActiveAccreditedSchools.vue?vue&type=style&index=0&id=6d3fd373&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3fd373",
  null
  
)

export default component.exports